module.exports = __webpack_public_path__ + "img/brand (16).40fa3941.svg";